import React, { useCallback, useEffect, useReducer, useState } from "react"
import { obterHistoricoCaixa } from "../../../services/historicoCaixa"
import useAppStore from "../../../stores/AppStore"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { HistoricoCaixaInicial } from "../models/historicoCaixaModel"
import { HistoricoCaixaActionsTypes } from "./historicoCaixaActions"
import { HistoricoCaixaContext } from "./HistoricoCaixaContext"
import { historicoCaixaReducer } from "./historicoCaixaReducer"

export function HistoricoCaixaContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(historicoCaixaReducer, HistoricoCaixaInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const [dataFiltro, setDataFiltro] = useState("")
    const setLoading = useLoadingStore(s => s.setLoading)
    const idEstabelecimento = useAppStore(
        s => s.configuracoes?.user?.parametros?.estabelecimento?.id
    )

    const carregar = useCallback(
        async (data?: string) => {
            const autorizacao = localStorage.getItem("chaveSistema")
            if (!autorizacao) return
            try {
                setLoading(true)
                const response = await obterHistoricoCaixa(
                    autorizacao,
                    data || undefined,
                    idEstabelecimento
                )
                if ("retornoErro" in response) {
                    setErroCarregamento(response.mensagem || "Erro ao carregar histórico do caixa")
                } else {
                    setErroCarregamento(null)
                    dispatch({ type: HistoricoCaixaActionsTypes.CARREGAR, payload: response })
                }
            } catch {
                setErroCarregamento("Erro ao carregar histórico do caixa")
            } finally {
                setLoading(false)
            }
        },
        [setLoading, idEstabelecimento]
    )

    useEffect(() => {
        carregar()
    }, [])

    return (
        <HistoricoCaixaContext.Provider
            value={{
                dados,
                dispatch,
                erroCarregamento,
                dataFiltro,
                setDataFiltro,
                recarregar: carregar,
            }}
        >
            <Loading />
            {children}
        </HistoricoCaixaContext.Provider>
    )
}
